import {ROUTES_WITHOUT_LOCALIZATION} from "../../constants/structure";
import { useLocation } from "react-router-dom";
import { PropsWithChildren } from "react";

interface IProps extends PropsWithChildren{
  hasBackButton?: boolean;
  source?: string;
}

export const LocalizationLayout = ({ children, source }: IProps) => {
  const { pathname } = useLocation();

  if (source === 'modal') {
    return <>{children}</>
  }

  return !ROUTES_WITHOUT_LOCALIZATION.includes(pathname) ? <>{children}</> : null;
};
